import React, { forwardRef } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "../hooks/useTranslation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons/faUpload";
import { LabelHint } from "./LabelHint";

type Props = {
  title?: string;
  maxFiles?: number;
  hint?: string;
  accept?: Record<string, string[]>;
  disabled?: boolean;
  onFileChange: ((files: File[]) => void) | null;
};

export const FileDropzone: React.FC<Props> = forwardRef(
  ({ accept, title, hint, maxFiles, disabled, onFileChange }, ref) => {
    const { t } = useTranslation();
    const { getRootProps, getInputProps } = useDropzone({
      maxFiles,
      disabled,
      accept: accept,
      onDrop: onFileChange != null ? onFileChange : () => {},
    });

    return (
      <div
        {...getRootProps()}
        className={
          "rounded text-center cursor-pointer flex flex-col justify-center align-items-center"
        }
        style={{ height: 150, border: "1px dashed gray" }}
      >
        <div ref={ref as any}></div>
        <input {...getInputProps()} />
        {title && (
          <div className={"p-0 m-0 text-muted text-sm"}>
            {title}{" "}
            {hint && (
              <LabelHint className={"inline-flex text-left"} hint={hint} />
            )}
          </div>
        )}
        <div className={"p-0 m-0 text-muted text-sm"}>
          {t("drag_and_drop_placeholder")}
        </div>
        <div className={"p-0 mt-3 text-muted"}>
          <FontAwesomeIcon icon={faUpload} size={"3x"} />
        </div>
      </div>
    );
  },
);
